import { useCrmebShell } from '@/config/crmeb-shell';

/** EB 平台端区域列表项（login/profile 驼峰） */
export type CrmebRegionItem = { circleId: number; name: string };

/** 从 AdminInfo 解析 regionName */
export function normalizeRegionList(
  admin: Record<string, unknown> | null | undefined,
): CrmebRegionItem[] {
  if (!admin) return [];
  const raw = admin.regionName;
  if (!Array.isArray(raw)) return [];
  return raw
    .map((item: Record<string, unknown>) => ({
      circleId: Number(item.circleId ?? 0),
      name: String(item.name ?? ''),
    }))
    .filter((z) => z.circleId > 0);
}

/** 区域代理当前 circleId：优先 localStorage，否则取首个绑定区域 */
export function resolveAgentZoneId(
  admin: Record<string, unknown>,
  storedZoneId?: number | string | null,
): number {
  const regions = normalizeRegionList(admin);
  if (!regions.length) return 0;
  let stored = storedZoneId;
  if (stored === undefined || stored === null || stored === '') {
    try {
      stored = localStorage.getItem('current_zone_id');
    } catch {
      stored = 0;
    }
  }
  const zid = Number(stored);
  if (zid > 0 && regions.some((r) => r.circleId === zid)) {
    return zid;
  }
  return regions[0].circleId;
}
